var BRAND_SENTENCES = {
  zh: [
    '这一步可以直接在 Miral 中继续完成。',
    '在 Miral 中可以沿用同一套流程继续测试。',
    '如果需要对比结果，可以在 Miral 中继续生成或处理。',
    '整个过程都可以在 Miral 的浏览器工作流中完成。'
  ],
  en: [
    'You can continue this step directly in Miral.',
    'Miral lets you test the same workflow without leaving the browser.',
    'You can compare the next result in Miral and keep refining from there.',
    'The full workflow can stay inside Miral from the first test to the final check.'
  ],
  ja: [
    'この手順は Miral でそのまま続けられます。',
    'Miral なら同じワークフローをブラウザ内でテストできます。',
    '次の結果も Miral で比較しながら調整できます。',
    '最初のテストから最終確認まで Miral 内で進められます。'
  ],
  ko: [
    '이 단계는 Miral에서 바로 이어서 진행할 수 있습니다.',
    'Miral에서는 같은 워크플로를 브라우저 안에서 테스트할 수 있습니다.',
    '다음 결과도 Miral에서 비교하며 계속 다듬을 수 있습니다.',
    '첫 테스트부터 최종 확인까지 Miral 안에서 진행할 수 있습니다.'
  ],
  fr: [
    'Vous pouvez poursuivre cette étape directement dans Miral.',
    'Miral permet de tester le même workflow sans quitter le navigateur.',
    'Vous pouvez comparer le résultat suivant dans Miral et continuer à l’affiner.',
    'Tout le workflow peut rester dans Miral, du premier test au contrôle final.'
  ],
  es: [
    'Puedes continuar este paso directamente en Miral.',
    'Miral permite probar el mismo flujo sin salir del navegador.',
    'Puedes comparar el siguiente resultado en Miral y seguir ajustándolo.',
    'Todo el flujo puede realizarse en Miral, desde la primera prueba hasta la revisión final.'
  ],
  it: [
    'Puoi continuare questo passaggio direttamente in Miral.',
    'Miral consente di testare lo stesso workflow senza uscire dal browser.',
    'Puoi confrontare il risultato successivo in Miral e continuare a perfezionarlo.',
    'L’intero workflow può restare in Miral, dal primo test al controllo finale.'
  ],
  de: [
    'Du kannst diesen Schritt direkt in Miral fortsetzen.',
    'Mit Miral lässt sich derselbe Ablauf vollständig im Browser testen.',
    'Das nächste Ergebnis kannst du in Miral vergleichen und weiter verfeinern.',
    'Der gesamte Ablauf kann vom ersten Test bis zur Endkontrolle in Miral bleiben.'
  ],
  pt: [
    'Você pode continuar esta etapa diretamente no Miral.',
    'O Miral permite testar o mesmo fluxo sem sair do navegador.',
    'Você pode comparar o próximo resultado no Miral e continuar refinando.',
    'Todo o fluxo pode permanecer no Miral, do primeiro teste à revisão final.'
  ],
  pl: [
    'Ten krok możesz kontynuować bezpośrednio w Miral.',
    'Miral pozwala przetestować ten sam workflow bez opuszczania przeglądarki.',
    'Kolejny wynik możesz porównać w Miral i dalej go dopracowywać.',
    'Cały proces może pozostać w Miral od pierwszego testu do końcowej kontroli.'
  ],
  ar: [
    'يمكنك متابعة هذه الخطوة مباشرة داخل Miral.',
    'يتيح لك Miral اختبار سير العمل نفسه دون مغادرة المتصفح.',
    'يمكنك مقارنة النتيجة التالية في Miral ومواصلة تحسينها.',
    'يمكن تنفيذ سير العمل كاملًا داخل Miral من الاختبار الأول حتى المراجعة النهائية.'
  ]
}

var BRAND_DECORATION_EXCLUDED_SLUGS = {
  'kimi-k3-review': true,
  'claude-fable-5-review': true,
  'gpt-5-6-sol-review': true,
  'ai-background-remover-online': true,
  'ecommerce-product-background-removal': true,
  'ai-portrait-background-remover': true,
  'ai-background-changer-online': true
}

function hasBrand(text) {
  return /\bMiral\b/i.test(String(text || ''))
}

function appendBrand(text, locale, index) {
  var value = String(text || '').trim()
  if (!value || hasBrand(value)) return value
  var sentences = BRAND_SENTENCES[locale] || BRAND_SENTENCES.en
  return value + ' ' + sentences[index % sentences.length]
}

function decorateArticleBrandContent(article, locale) {
  if (!article) return article
  // These are independent model reviews. Their models are not available in
  // Miral, so generic product sentences would be misleading and repetitive.
  if (BRAND_DECORATION_EXCLUDED_SLUGS[article.slug]) return article
  var counter = 0
  article.excerpt = appendBrand(article.excerpt, locale, counter++)
  ;(article.sections || []).forEach(function (section) {
    ;(section.blocks || []).forEach(function (block) {
      if (block.type !== 'paragraph') return
      block.text = appendBrand(block.text, locale, counter++)
    })
  })
  return article
}

module.exports = {
  BRAND_SENTENCES: BRAND_SENTENCES,
  decorateArticleBrandContent: decorateArticleBrandContent
}
